import type { ApprovalStage } from '@/types/approvalWorkflow';

/**
 * Computes a stage's effective rule count, preferring the `ruleCount`
 * (preApproval + postApproval) totals and falling back to the length of the
 * `rules` array. Keeps CompactStageCard, FlowNode, and WorkflowVisualFlow
 * consistent.
 */
export function getStageRuleCount(stage: ApprovalStage): number {
  const total =
    (stage.ruleCount?.preApproval ?? 0) + (stage.ruleCount?.postApproval ?? 0);
  return total || stage.rules?.length || 0;
}

/**
 * Whether a stage has any routing/rule configuration, accounting for
 * `ruleCount` totals, the `rules` array, and the `routingConfigured` flag.
 */
export function stageHasRules(stage: ApprovalStage): boolean {
  return getStageRuleCount(stage) > 0 || stage.routingConfigured === true;
}
